<template>
  <div class="fixed inset-x-0 bottom-0 z-40 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-50" />
    </div>

    <div class="transform overflow-hidden bg-white px-4 pb-4 pt-5 shadow-xl transition-all sm:w-full sm:max-w-lg sm:p-6">
      <div class="sm:flex sm:items-start">
        <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
          <svg
            class="h-6 w-6 text-red-600"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <h3 class="brand-heading text-lg font-medium leading-6 text-gray-900">
            {{ title }}
          </h3>
          <div class="mt-2">
            <p class="brand-body text-sm leading-5 text-gray-500">
              {{ message }}
            </p>
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <span
          class="flex w-full shadow-sm sm:ml-3 sm:w-auto"
          @click="confirm"
        >
          <button
            type="button"
            class="brand-button focus:shadow-outline-red inline-flex w-full justify-center border border-transparent bg-red-600 px-4 py-2 text-base font-medium leading-6 text-white
            shadow-sm transition duration-150 ease-in-out hover:bg-red-500 focus:border-red-700 focus:outline-none sm:leading-5"
          >
            Confirm
          </button>
        </span>
        <span
          class="mt-3 flex w-full sm:mt-0 sm:w-auto"
          @click="cancel"
        >
          <button
            type="button"
            class="brand-button-secondary inline-flex w-full justify-center px-4 py-2 text-base leading-6 transition
            duration-150 ease-in-out hover:text-secondary-500 focus:outline-none sm:leading-5"
          >
            Cancel
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  components: {

  },

  props: {
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
    };
  },

  methods: {
    confirm() {
      this.$emit('result', true);
    },

    cancel() {
      this.$emit('result', false);
    },
  },
};
</script>
